const DISCOUNT_BENEFIT_BINS = [
  '458016',
  '458026',
  '458080',
  '458096',
  '458086',
  '364094',
  '365567',
  '518989',
  '518991',
  '536407',
  '547714',
  '552184',
  '545137',
  '364097',
  '364098',
  '364269',
  '365561',
  '458006',
  '555888',
  '458093',
  '458023',
  '421915',
  '407517',
];

export default {
  DISCOUNT_BENEFIT_BINS,
};



// WEBPACK FOOTER //
// ./src/constants/discount-benefit-bins.js